import React from "react";
import { Table, Row, Col } from "react-bootstrap";

export default function TableLargeAntrian(props) {
  const { dataTable } = props;
  // console.log("data: ", dataTable);
  return (
    <Row>
      <Col lg="12" md="12">
        <Table bordered hover responsive>
          <tbody>
            <tr>
              <th               
                style={{ backgroundColor: "#4CAF50", color: "white" }}
              >
                <strong>Nama Poli</strong>
              </th>
              <th               
                style={{ textAlign:"center", backgroundColor: "#4CAF50", color: "white" }}
              >
                <strong>Antrian</strong>
              </th>
              
              <th               
                style={{ textAlign:"center",backgroundColor: "#4CAF50", color: "white" }}
              >
                <strong>Total Pasien</strong>
              </th>
              <th               
                style={{ backgroundColor: "#4CAF50", color: "white" }}
              >
                <strong>Dokter</strong>
              </th>
            </tr>
            {dataTable?.rows?.length > 0 ? (
              <>
                {dataTable?.rows?.map((obj, idx) => (
                  <tr key={idx}>
                    <td>{obj?.namaunit}</td>
                    <td style={{ textAlign:"center" }}><b><span style={{color:"red"}}> {obj?.antrian}</span></b></td>
                    <td style={{ textAlign:"center" }}><b><span style={{color:"black"}}> {obj?.total}</span></b></td>
                    <td>{obj?.dokter}</td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="4">Tidak ada antrian hari ini...</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Col>
 
    </Row>
  );
}
